import Vue from 'vue'
import { i18n } from '../i18n.js'

Vue.filter('translate', value => {
    if (value == '') { return }
    let localeData = i18n.messages[i18n.locale];
    return localeData[value] ? localeData[value].message : '%%'+value+'%%';
});